"use client";

import { logo_white } from "@/images";
import { cn } from "@/lib";
import { replaceImage } from "@/utils";
import Image from "next/image";
import { useState } from "react";

const CommonImage =({
    src,
    alt,
    ...props
}: any) => {
    const [imageError, setImageError] = useState(false);

    return (
        <Image
            {...props}
            // Always ship a non-empty alt for accessibility & image SEO; callers
            // that pass a descriptive alt keep theirs.
            alt={alt || 'Greet event'}
            src={imageError ? logo_white : replaceImage(src)}
            onError={() => setImageError(true)}
            className={cn(props.className, imageError && 'bg-black object-contain')}
        />
    );
}

export default CommonImage;